import axiosInstance from '../axiosInterceptor/axiosInstance'

const FILENAME_RE = /filename\*?=(?:UTF-8'')?["']?([^"';]+)["']?/i

const downloadOverlayLinks = async ({ orgId, gameId }) => {
  // No leading slash: the interceptor only drops the baseURL's /api for urls starting with v1.
  const response = await axiosInstance.get(`v1/orgs/${orgId}/games/${gameId}/overlay-links`, {
    responseType: 'blob',
  })

  const disposition = response.headers['content-disposition'] || ''
  const match = FILENAME_RE.exec(disposition)
  const filename = match ? decodeURIComponent(match[1]) : `overlay-links-${gameId}.txt`

  const objectUrl = window.URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = objectUrl
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(objectUrl)
}

export default downloadOverlayLinks
